export default __webpack_public_path__ + "static/media/bgMobileGreen.f2fa0c6d.svg";